import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LoginShareDataService {
    private emailDetail = new BehaviorSubject<string | null>(null);
    emailDetailData = this.emailDetail.asObservable();

    setEmailData(email: string) {
        this.emailDetail.next(email)
    }
}